export enum ModalsTypeEnum {
  ReportNo = 1,
  Police = 2,
  Arrest = 3,
  Neighborhood = 4,
  PoliceDepartments = 5,
  BAC = 6,
  Client = 7,
  Category = 8,
  Defense = 9,
  Stage = 10,
  ProbOfficer = 11,
  CoCounsel = 12,
  Notes = 13,
  Jurisdiction = 14,
  TestType = 15,
  ContactInfo = 16,
  Attorney = 17,
  PromptChoice = 18,
}
